module.exports = __webpack_public_path__ + "img/moren-tuijian.6fb8136b.jpg";